import React from 'react'
import './workWithUS.css';

const WorkWithUS = () => {
  return (
    <div className='work section_padding'>
      <div className='work__heading'>
            <h1 className='title'>Why Work With Us</h1>
            <p className='text'>We define business processes through ideation, creation, and optimization with a team of exceptional strategists.</p>
      </div>
      <div className='container'>
        <div className='work-card work-first-card'>
          <div className='icon'>
          </div>
          <div>
            <h4>Agile throughout our processes</h4>
            <p>We ideate and develop unique software solutions to help businesses meet their exact objectives.</p>
          </div>         
        </div> 
        
        <div className='work-card work-second-card'>
          <div className='icon'>
          </div>
          <div>
            <h4>Go live on internet</h4>
            <p>We ideate and develop unique software solutions to help businesses meet their exact objectives.</p>
          </div>         
        </div> 

        <div className='work-card work-third-card'>
          <div className='icon'>
          </div>
          <div>
            <h4>Ensure Fastest delivery</h4>
            <p>We ideate and develop unique software solutions to help businesses meet their exact objectives.</p>
          </div>         
        </div> 
      </div>
    </div>
  )
}

export default WorkWithUS